<template>
  <div class="page-container">
    <div class="page-header">
      <div>
        <h2 class="page-title">系统参数</h2>
      </div>
      <div class="page-header-extra">
        <span>共 <b>{{ list.length }}</b> 个参数</span>
      </div>
    </div>

    <el-card class="search-card" shadow="never">
      <el-tabs v-model="activeGroup" @tab-click="handleTabClick">
        <el-tab-pane v-for="g in groups" :key="g.value" :label="g.label" :name="g.value" />
      </el-tabs>
      <div class="search-bar">
        <el-form :inline="true" :model="query" size="small" class="search-form">
          <el-form-item label="参数">
            <el-input v-model="query.keyword" placeholder="参数键或名称" clearable style="width: 180px" />
          </el-form-item>
          <el-form-item label="分组">
            <el-select v-model="query.group" placeholder="全部" clearable style="width: 130px">
              <el-option v-for="g in groupOptions" :key="g.value" :label="g.label" :value="g.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="query.input_type" placeholder="全部" clearable style="width: 130px">
              <el-option v-for="t in inputTypes" :key="t.value" :label="t.label" :value="t.value" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="action-bar">
          <el-button v-if="isSuper" type="primary" icon="el-icon-plus" size="small" @click="handleAdd">新增参数</el-button>
        </div>
      </div>
    </el-card>

    <el-card class="table-card" shadow="never">
      <el-table v-loading="loading" :data="list" border size="small" height="100%">
        <el-table-column prop="config_key" label="参数键" min-width="180">
          <template slot-scope="scope">
            <code>{{ scope.row.config_key }}</code>
          </template>
        </el-table-column>
        <el-table-column prop="config_name" label="参数名称" min-width="160"/>
        <el-table-column label="参数值" min-width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.input_type === 'switch'">
              <el-tag :type="scope.row.config_value === '1' ? 'success' : 'info'" size="mini" effect="plain">
                {{ scope.row.config_value === '1' ? '开启' : '关闭' }}
              </el-tag>
            </span>
            <span v-else>{{ scope.row.config_value || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="分组" width="110">
          <template slot-scope="scope">{{ groupLabel(scope.row.group) }}</template>
        </el-table-column>
        <el-table-column label="类型" width="90">
          <template slot-scope="scope">{{ inputTypeLabel(scope.row.input_type) }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="说明" min-width="180" show-overflow-tooltip/>
        <el-table-column prop="sort" label="排序" width="70" align="center"/>
        <el-table-column v-if="isSuper" label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" class="text-danger-btn" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      :title="form.id ? '编辑参数' : '新增参数'"
      :visible.sync="dialogVisible"
      width="720px"
      top="8vh"
      class="form-dialog"
      append-to-body
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="110px" label-position="right" class="dialog-form">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="参数键" prop="config_key">
              <el-input v-model="form.config_key" :disabled="!!form.id" placeholder="如 service_phone" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参数名称" prop="config_name">
              <el-input v-model="form.config_name" placeholder="如 客服电话" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="表单类型">
              <el-select v-model="form.input_type" style="width: 100%" @change="handleInputTypeChange">
                <el-option v-for="t in inputTypes" :key="t.value" :label="t.label" :value="t.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分组">
              <el-select v-model="form.group" style="width: 100%">
                <el-option v-for="g in groupOptions" :key="g.value" :label="g.label" :value="g.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="参数值">
          <el-switch
            v-if="form.input_type === 'switch'"
            v-model="form.config_value"
            active-value="1"
            inactive-value="0"
            active-text="开启"
            inactive-text="关闭"
          />
          <el-input
            v-else-if="form.input_type === 'textarea'"
            v-model="form.config_value"
            type="textarea"
            :rows="3"
          />
          <el-input v-else v-model="form.config_value" :type="form.input_type === 'number' ? 'number' : 'text'" placeholder="参数取值" />
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model="form.remark" type="textarea" :rows="3" maxlength="255" show-word-limit placeholder="该参数的用途说明，便于运营维护" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :max="999" controls-position="right" />
          <span class="form-tip">数字越小越靠前</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getConfigList, createConfig, updateConfig, deleteConfig } from '@/api/system'

const emptyForm = () => ({
  id: 0, company_id: 0, config_key: '', config_name: '', config_value: '',
  group: 'basic', input_type: 'text', remark: '', sort: 1
})

export default {
  name: 'ConfigManage',
  data() {
    return {
      loading: false,
      submitting: false,
      list: [],
      activeGroup: 'all',
      query: { keyword: '', group: '', input_type: '' },
      dialogVisible: false,
      form: emptyForm(),
      groups: [
        { value: 'all', label: '全部' },
        { value: 'basic', label: '基础' },
        { value: 'contact', label: '联系' },
        { value: 'reservation', label: '预约' },
        { value: 'content', label: '内容' }
      ],
      inputTypes: [
        { value: 'text', label: '单行文本' },
        { value: 'textarea', label: '多行文本' },
        { value: 'number', label: '数字' },
        { value: 'switch', label: '开关' },
        { value: 'select', label: '下拉' },
        { value: 'image', label: '图片' }
      ],
      rules: {
        config_key: [{ required: true, message: '请输入参数键', trigger: 'blur' }],
        config_name: [{ required: true, message: '请输入参数名称', trigger: 'blur' }],
        config_value: [{ required: true, message: '请填写参数值', trigger: 'blur' }]
      }
    }
  },
  computed: {
    groupOptions() {
      return this.groups.filter(i => i.value !== 'all')
    },
    isSuper() {
      const user = this.$store.getters.getUserInfo || {}
      return Number(user.is_super) === 1
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    // 拉取列表：筛选全交服务端（keyword 模糊 / group 精确 / input_type 精确）
    // Tab 与「分组」下拉同为分组维度，Tab 优先，两者都为空则取全部分组
    loadData() {
      this.loading = true
      const group = this.activeGroup !== 'all' ? this.activeGroup : (this.query.group || '')
      getConfigList({
        keyword: this.query.keyword || '',
        group,
        input_type: this.query.input_type || ''
      }).then(res => {
        this.loading = false
        if (res.code !== 200) return
        this.list = res.data.list || []
      }).catch(() => {
        this.loading = false
      })
    },
    groupLabel(val) {
      const g = this.groups.find(i => i.value === val)
      return g ? g.label : val
    },
    inputTypeLabel(val) {
      const t = this.inputTypes.find(i => i.value === val)
      return t ? t.label : val
    },
    // 切到开关类型且当前值非 1/0 时，兜底落 "0"，避免空值撞后端「参数值必填」
    handleInputTypeChange(val) {
      if (val === 'switch' && this.form.config_value !== '1' && this.form.config_value !== '0') {
        this.form.config_value = '0'
      }
    },
    handleTabClick() {
      this.loadData()
    },
    handleSearch() {
      this.loadData()
    },
    resetSearch() {
      this.query = { keyword: '', group: '', input_type: '' }
      this.activeGroup = 'all'
      this.loadData()
    },
    handleAdd() {
      this.form = emptyForm()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    handleEdit(row) {
      this.form = Object.assign(emptyForm(), row)
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    // 提交白名单：编辑不带 config_key（后端也忽略）；config_value 统一转字符串
    buildPayload() {
      const payload = {
        config_name: this.form.config_name,
        config_value: String(this.form.config_value == null ? '' : this.form.config_value),
        input_type: this.form.input_type,
        group: this.form.group,
        remark: this.form.remark || '',
        sort: this.form.sort
      }
      if (!this.form.id) payload.config_key = this.form.config_key
      return payload
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitting = true
        const payload = this.buildPayload()
        const req = this.form.id ? updateConfig(this.form.id, payload) : createConfig(payload)
        req.then(res => {
          this.submitting = false
          // 响应拦截器对业务错误只弹 error 但仍 resolve，须自判 code
          if (res.code !== 200) return
          this.$message.success(this.form.id ? '已保存修改' : '新增成功')
          this.dialogVisible = false
          this.loadData()
        }).catch(() => {
          this.submitting = false
        })
      })
    },
    handleDelete(row) {
      this.$confirm(`确认删除参数「${row.config_name}」？`, '删除确认', { type: 'warning' }).then(() => {
        deleteConfig(row.id).then(res => {
          if (res.code !== 200) return
          this.$message.success('已删除')
          this.loadData()
        })
      }).catch(() => {})
    }
  }
}
</script>
